import { apiClient } from '@/api/api-client';
import {
  audioTextCorrectionRequestSchema,
  audioTextCorrectionResultSchema,
  type AudioTextCorrectionRequest,
  type AudioTextCorrectionResult,
} from './audio-text-correction.contract';

export async function correctAudioText(
  audioId: string,
  request: AudioTextCorrectionRequest,
): Promise<AudioTextCorrectionResult> {
  const body = audioTextCorrectionRequestSchema.parse(request);
  const { data } = await apiClient.patch<unknown>(`/validation/${encodeURIComponent(audioId)}/text`, body);
  return audioTextCorrectionResultSchema.parse(data);
}
